import { http, HttpResponse } from 'msw';

import { SummaryResponse } from '../../api/getSummary';

const summaryResponse: SummaryResponse = {
    amount: {
        amount: 27500,
        currency: 'NOK',
    },
    tenor: {
        months: 60,
        years: 5,
        yearsMonthsRemainder: 0,
    },
    monthlyCost: {
        amount: 2254,
        currency: 'NOK',
    },
    isConsolidation: true,
    selectedConsolidations: [
        {
            accountType: 'REPAYMENT_LOANS',
            creditorName: 'Bank Norwegian',
            internalId: '123456789',
            shortId: '12345',
            currentBalance: {
                amount: 12500,
                currency: 'NOK',
            },
            nominalInterestRate: 0,
            tenor: 0,
            accountNumber: '9999999999',
            kidNumber: '888888888',
            applicantType: 'MAIN',
        },
        {
            accountType: 'REPAYMENT_LOANS',
            creditorName: 'Bank Norwegian',
            internalId: '123456789',
            shortId: '12345',
            currentBalance: {
                amount: 15000,
                currency: 'NOK',
            },
            nominalInterestRate: 0,
            tenor: 0,
            accountNumber: '9999999999',
            kidNumber: '888888888',
            applicantType: 'CO',
        },
    ],
};

export const getSummaryHandler = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/summary', async () => {
        return HttpResponse.json(summaryResponse);
    }),
];
